import { SearchIcon } from "./icons";

export default function HelpHero({
  searchQuery,
  onSearchChange,
}: {
  searchQuery: string;
  onSearchChange: (v: string) => void;
}) {
  return (
    <section className="px-6 sm:px-10 lg:px-20">
      <div className="rounded-3xl bg-muted px-6 pb-10 pt-12 sm:px-10 lg:px-16 lg:pb-16">
        <h1 className="text-[28px] font-bold leading-[1.4] tracking-[-1px] text-foreground sm:text-[40px] md:text-[52px] lg:text-[64px]">
            How can we help you?
        </h1>

        <div className="mt-6 flex flex-col gap-6 lg:mt-10 lg:flex-row lg:items-end lg:justify-between lg:gap-16">
            <p className="max-w-193.5 text-xs leading-5 text-muted-foreground sm:text-sm sm:leading-6">
                Find answers to common questions, learn how to use Podus AI, review our
                terms and privacy policy, or get in touch with our support team.
                We&rsquo;re here to make your legal journey as clear and stress-free as possible.
            </p>

            <div className="flex h-12 w-full max-w-182.5 items-center rounded-lg border border-input bg-background px-5">
                <input
                    type="text"
                    placeholder="Search for answers…"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="flex-1 bg-transparent text-sm leading-6 text-foreground placeholder:text-text-light focus:outline-none"
                />
                <SearchIcon />
            </div>
        </div>
      </div>
    </section>
  );
}
